module.exports = __webpack_public_path__ + "static/media/my-intent.8c494622.png";